// extracted by mini-css-extract-plugin
var _1 = "SummaryBeast__beast--Ezk8y";
var _2 = "SummaryBeast__beastTest--nN7aK SummaryBeast__beast--Ezk8y";
var _3 = "SummaryBeast__challenge--Kuia1 SummaryBeast__message--xm6dc";
var _4 = "SummaryBeast__fiona--bOzYX SummaryBeast__message--xm6dc";
var _5 = "SummaryBeast__grok--bh7dt SummaryBeast__message--xm6dc";
var _6 = "SummaryBeast__inner--Xn2zT";
var _7 = "SummaryBeast__kraken--e77qw SummaryBeast__message--xm6dc";
var _8 = "SummaryBeast__main--foNhN";
var _9 = "SummaryBeast__message--xm6dc";
var _a = "SummaryBeast__review--f4u1E SummaryBeast__message--xm6dc";
var _b = "SummaryBeast__rote--zaPJb SummaryBeast__message--xm6dc";
var _c = "SummaryBeast__test--IU6xr SummaryBeast__message--xm6dc";
export { _1 as "beast", _2 as "beastTest", _3 as "challenge", _4 as "fiona", _5 as "grok", _6 as "inner", _7 as "kraken", _8 as "main", _9 as "message", _a as "review", _b as "rote", _c as "test" }
